import getCurrentOS from './get-current-os'

export { getCurrentOS }



// WEBPACK FOOTER //
// ./shared/util/env/index.js